import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { G } from "@/brand";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Verify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setError("Missing token."); return; }
    api.post("/auth/verify", { token })
      .then(({ data }) => { login(data.user); nav("/dashboard"); })
      .catch((e) => setError(apiError(e.response?.data?.detail) || e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: G.black, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 18, padding: 24 }}>
      {!error ? (
        <>
          <div className="spinner" />
          <div className="mono" style={{ color: G.gold, fontSize: 11, letterSpacing: ".2em" }}>SIGNING YOU IN…</div>
        </>
      ) : (
        <>
          <div style={{ color: "#fff", fontSize: 22, fontStyle: "italic" }}>{error}</div>
          <button onClick={() => nav("/")} className="btn-gold" style={{ padding: "12px 26px", fontSize: 10 }}>Back Home</button>
        </>
      )}
    </div>
  );
}
